<div class="default-dialog">
    <div class="dialog-header">
        <h3>{{ 'PRODUCT_DETAILS_DIALOG.HEADER' | translate }}</h3>
        <div class="header-close">
            <button mat-icon-button color="primary" mat-dialog-close>
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
    <mat-dialog-content>
        <div class="product-details">
            <div class="product-details-header">
                {{ data.description }}
            </div>
            @if (data.technicalAttributes) {
            <div class="product-detail-attributes">
                <div class="product-detail-attributes-header">
                    {{ 'PRODUCT_DETAILS_DIALOG.ATTRIBUTES.HEADER' | translate }}
                </div>
                @for (attribute of data.technicalAttributes; track attribute.attributeId) {
                <div class="product-detail-attribute">
                    <div class="attribute-description">
                        {{ attribute.description }}
                    </div>
                    @for (value of attribute.values; track value.valueId) {
                    <div class="attribute-value">{{ formatDecimalComma(value.value) }} {{ value.unit }}</div>
                    }
                </div>
                }
            </div>
            } @if (data.packageContents) {
            <div class="product-detail-package-contents">
                <div class="product-detail-package-contents-header">
                    {{ 'PRODUCT_DETAILS_DIALOG.PACKAGE_CONTENT.HEADER' | translate }}
                </div>
                @for (packageContent of data.packageContents; track packageContent._id) {
                <div class="product-detail-package-content">
                    <div class="package-content-material">
                        {{ packageContent.referenceMetadata.amount }} x {{ packageContent.name }}
                    </div>
                    <div class="package-content-name">{{ packageContent.description }}</div>
                </div>
                }
            </div>
            }
        </div>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button mat-button mat-dialog-close color="primary">{{ 'COMMON.DIALOG.CLOSE' | translate }}</button>
    </mat-dialog-actions>
</div>
